import reducer from './reducers';
import * as managersActions from './actions';
import * as managersSelectors from './selectors';

export { managersActions, managersSelectors };
export default reducer;